import { memo } from "react"

const Emoji = memo(({ label, emotionId }: { label:string , emotionId: string }) =>
    <span role="img" aria-label={label}>
      {emotionId}
    </span>
)

export default Emoji